import { useEffect, useRef } from 'react'
import { toast } from 'sonner'

import { filePath, receiptSettled, useUploadReceipt } from '@/models/vault'
import { useVault } from './VaultContext'
import { FILED_TOAST_MS, FiledToast } from './VaultUploadToast'

/**
 * Waits for the parser to read one uploaded document, then says where it was
 * filed. Renders nothing — one of these rides along per upload in flight.
 */
export function VaultUploadWatcher({ documentId, onSettled }: { documentId: string; onSettled: () => void }) {
  const { orgId, href } = useVault()
  const { receipt } = useUploadReceipt(orgId, documentId)
  const handled = useRef(false)
  const settledRef = useRef(onSettled)
  settledRef.current = onSettled

  useEffect(() => {
    if (handled.current || !receiptSettled(receipt)) return
    handled.current = true
    const to = href(filePath(receipt.fileKind, receipt.subjectId ?? undefined))
    toast.custom(
      (id) => (
        <FiledToast
          subjectName={receipt.subjectName}
          slotLabel={receipt.slotLabel}
          to={to}
          onView={() => toast.dismiss(id)}
        />
      ),
      { duration: FILED_TOAST_MS }
    )
    settledRef.current()
  }, [receipt, href])

  return null
}
